var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Utils, CustomElement, Watch, PropertyConverters, PacemEventTarget } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
const THRESHOLD_SM = 768;
const THRESHOLD_MD = 992;
const THRESHOLD_LG = 1200;
const THRESHOLD_XL = 1824;
const THRESHOLD_HD = 1920;
const THRESHOLD_2K = 2048;
const THRESHOLD_4K = 3840;
export const MEDIAQUERY_XS = `(max-width: ${(THRESHOLD_SM - 1)}px)`;
export const MEDIAQUERY_SM = `(min-width: ${THRESHOLD_SM}px)`;
export const MEDIAQUERY_MD = `(min-width: ${THRESHOLD_MD}px)`;
export const MEDIAQUERY_LG = `(min-width: ${THRESHOLD_LG}px)`;
export const MEDIAQUERY_XL = `(min-width: ${THRESHOLD_XL}px)`;
export const MEDIAQUERY_HD = `(min-width: ${THRESHOLD_HD}px)`;
export const MEDIAQUERY_2K = `(min-width: ${THRESHOLD_2K}px)`;
export const MEDIAQUERY_4K = `(min-width: ${THRESHOLD_4K}px)`;
export const MEDIAQUERY_PORTRAIT = `(orientation: portrait)`;
export const MEDIAQUERY_LANDSCAPE = `(orientation: landscape)`;
export const MEDIAQUERY_PREFERS_LIGHT = `(prefers-color-scheme: light)`;
export const MEDIAQUERY_PREFERS_DARK = `(prefers-color-scheme: dark)`;
let PacemMediaQueryElement = class PacemMediaQueryElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._changeHandler = (evt) => {
            this.isMatch = evt.matches;
        };
    }
    #mql;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._init();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'query':
                if (!first) {
                    this._init();
                }
                break;
            case 'isMatch':
                // dedicated change events
                this._broadcastChange(val);
                break;
        }
    }
    disconnectedCallback() {
        this._init('');
        super.disconnectedCallback();
    }
    _broadcastChange(val = this.isMatch) {
        this.dispatchEvent(new Event('change'));
        this.dispatchEvent(new Event(val ? 'match' : 'unmatch'));
    }
    _init(q = this.query) {
        const old = this.#mql;
        if (!Utils.isNull(old)) {
            old.removeEventListener('change', this._changeHandler);
        }
        if (!Utils.isNullOrEmpty(q)) {
            const val = this.#mql = window.matchMedia(q);
            val.addEventListener('change', this._changeHandler);
            this.isMatch = val.matches;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMediaQueryElement.prototype, "query", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Boolean })
], PacemMediaQueryElement.prototype, "isMatch", void 0);
PacemMediaQueryElement = __decorate([
    CustomElement({
        tagName: P + '-media-query'
    })
], PacemMediaQueryElement);
export { PacemMediaQueryElement };
